var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGroup = function SvgGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#475467",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M7 10H5.333c-1.242 0-1.864 0-2.354.203-.653.27-1.172.79-1.443 1.443-.203.49-.203 1.111-.203 2.354m9-11.806a2.668 2.668 0 0 1 0 4.945M9 4.667a2.667 2.667 0 1 1-5.333 0 2.667 2.667 0 0 1 5.333 0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#group_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#475467",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M11.767 15.205c.074.043.111.065.163.076.04.008.1.008.14 0 .052-.011.089-.033.163-.076.649-.379 2.434-1.569 2.434-3.205v-1.594c0-.267 0-.4-.044-.514a.7.7 0 0 0-.182-.263c-.092-.082-.217-.128-.466-.222l-1.788-.67a.7.7 0 0 0-.14-.044.3.3 0 0 0-.095 0c-.035.005-.07.018-.14.044l-1.787.67c-.25.094-.374.14-.466.222a.7.7 0 0 0-.182.263c-.044.114-.044.247-.044.514V12c0 1.636 1.785 2.826 2.434 3.205"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "group_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 8h8v8H8z"
  })))));
};
export default SvgGroup;